jQuery(function($) {

    window.post = {}
    let $archive_title = $('title').text().split('|')[0];

    window.post.featuredImage = function() {
        $.each($('.featured-image:not(.loaded)'), function() {
            let $this = $(this)
            $this.find('.large').attr('srcset', $this.data('large'))
            $this.find('img').attr('src', $this.data('large'))
            $this.addClass('loaded')
        })
    }

    window.post.scrollVideo = function() {
        let url = window.location.href
        let $video = $('article iframe')

        if (url.search('#video') != -1 && $video.length) {
            $('html, body')
                .stop()
                .animate({
                    scrollTop: $video.offset().top - 140
                }, 1, 'swing')
        }
    }

    window.post.slickInit = function() {
      if( typeof $.fn.slick == 'function' ) {
        $('.slick:not(.slick-initialized)').slick()
      }
    }

    window.post.more = function() {

      let $this = $(this)
  
      $this
        .attr('disabled', 'disabled')
        .addClass('loading')
  
      $.get( $this.data('url'), function( data, status ) {
        content = $( $.parseHTML( data ) ).find('#articles').html()
        $this
          .parent()
          .replaceWith( content )
  
        window.post.observer()
      })
    }
  
    window.post.observerCallback = function(entries, observer) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          let $group = $(entry.target)
          let title = $('title').html()

          window.history.pushState({ state: $group.data('paged') }, title, url.current + '/page/' + $group.data('paged') + '/')
        }
      })
    }
  
    window.post.observer = function() {
      if ('IntersectionObserver' in window) {
        let groups = document.querySelectorAll('.article-group')
        let object = new IntersectionObserver(
          window.post.observerCallback, {
            threshold: 0
          }
        )
        for (const group of groups) {
          object.observe(group)
        }
      }
    }

    window.post.eventListeners = function() {
      let $window = $(window)
      let $body = $('body')
      let $articles = $('.articles')

      if ($body.hasClass('single')) {
        $articles
          .on('nextPost:loaded', window.post.slickInit)
          .on('nextPost:loaded', window.post.featuredImage)

        $window
          .on('load', window.post.scrollVideo)
          .on('load', window.post.featuredImage)
          
        $('body').on( 'click', '.more-articles', window.post.more )
      }
    }

    window.post.eventListeners()
    window.post.observer()
})



// WEBPACK FOOTER //
// ./src/js/post.js